import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Candidature} from '../candidature.model';
import {Cursus} from '../cursus.model';
import {Bac, Departement, GrhumService, Mention, Pays} from '../../grhum';
import {Response} from '@angular/http';
import {CursusService} from '../cursus.service';
import {CodeTypeEtablissement, CONSTANTS} from '../../../cadens.constants';
import { Parametrage, ParametrageService } from '../../parametrage';
import {Concours} from '../concours.model';
import {ConcoursService} from '../concours.service';
import {JhiLanguageService} from 'ng-jhipster';
import {CandidatureFormation} from '../candidature-formation.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BacSpecialite } from '../../grhum/bacspecialite.model';
import {ListeChoix} from "../../../shared/ListeChoix/listeChoix.model";
import {ListeChoixService} from "../../../shared/ListeChoix/listeChoix.service";

@Component({
    selector: 'jhi-scolarite-component',
    templateUrl: './scolarite.component.html'
})
export class ScolariteComponent implements OnInit {

    @Input() candidature: Candidature;
    @Input() candidatureFormation: CandidatureFormation;
    @Input() paysListe: Pays[];
    @Input() deptListe: Departement[];

    @Input() courses: Cursus[];
    @Output() coursesChange: EventEmitter<Cursus[]> = new EventEmitter();

    @Input() concours: Concours[];
    @Output() concoursChange: EventEmitter<Concours[]> = new EventEmitter();

    @Input() isEditable: Boolean;
    bacsListe: Bac[];
    mentionsListe: Mention[];
    bacSpecialitesListe: BacSpecialite[];
    listeEchelons: ListeChoix[];
    typesEtablissement: string[];
    parametrage: any;
    currentLang: string;
    annee: any[] = [];
    aide: Parametrage;
    displayBacDetail = false;

    constructor(public grhumService: GrhumService,
                public cursusService: CursusService,
                public concoursService: ConcoursService,
                private jhiLanguageService: JhiLanguageService,
                private parametrageService: ParametrageService,
                private listeChoixService: ListeChoixService,
                private modalService: NgbModal) {
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }

    ngOnInit() {
        //this.candidature.echelon= "";

        if (this.candidature.id > 0) {
            this.cursusService.query({'candidatureId': this.candidature.id}).subscribe(
                (res: Response) => {
                    this.courses = res.json();
                    if (!this.courses || this.courses.length === 0) {
                        this.courses = [];
                        if (this.candidatureFormation.reinscription) {
                            this.courses.push(this.newCursusReinscription());
                        }
                    }
                    this.coursesChange.emit(this.courses);
                });
            this.concoursService.query({'candidatureId': this.candidature.id}).subscribe(
                (res: Response) => {
                    this.concours = res.json();
                    this.concoursChange.emit(this.concours);
                });
        }
        this.parametrageService.query({page: CONSTANTS.SCOLARITE}).subscribe(
            (res: Response) => {
                this.parametrage = this.parametrageService.parametresArrayToObject(res.json());
            });
        this.grhumService.queryBac().subscribe(
            (res: Response) => {
                this.bacsListe = res.json();
            });
        this.typesEtablissement = CodeTypeEtablissement;
        this.grhumService.queryGMention().subscribe(
            (res: Response) => {
                this.mentionsListe = res.json();
            });
        this.grhumService.queryBacSpecialite().subscribe(
            (res: Response) => {
                this.bacSpecialitesListe = res.json();
            });
        this.listeChoixService.query({type: CONSTANTS.ECHELON}).subscribe(
            (res: Response) => {
                this.listeEchelons = res.json();
            });
        this.updateDisplayBacDetail();
    }

    addCursus() {
        if (!this.courses) {
            this.courses = [];
        }
        this.courses.push(this.newCursus());
        this.coursesChange.emit(this.courses);
    }

    clearCursus(index) {
        this.courses.splice(index, 1);
    }

    private newCursus() {
        return { candidatureId: this.candidature.id };
    }

    private newCursusReinscription() {
        return {
            candidatureId: this.candidature.id,
            interruption: false,
            pays: '100',
            dept: '069',
            etablissement: '0694123G',
            ville: '69387' };
    }

    onChangeConcours(idx) {
        this.concours[idx].rang = null;
        this.concours[idx].annee = null;
        this.concours[idx].resultat = null;
    }
    onChangeBourse() {
        if (this.candidature.bourse == false) {
            this.candidature.echelon = "";
        }
    }
    onChangeTypeEtab() {
        this.candidature.bacPays = null;
        this.candidature.bacDept = null;
        this.candidature.bacVille = null;
        this.candidature.bacEtab = null;
        this.candidature.bacEtablissementAutre = null;
        this.candidature.bacSpec1LibelleCourt = null;
        this.candidature.bacSpec2LibelleCourt = null;
        this.verifBacFrancaisApres2021AndUpdateDisplayBacDetail();
        this.updateDisplayBacDetail();
    }

    onChangeBacAnnee() {
        this.verifBacFrancaisApres2021AndUpdateDisplayBacDetail();
        this.updateDisplayBacDetail();
    }

    verifBacFrancaisApres2021AndUpdateDisplayBacDetail() {
        if(Candidature.areSpecialitesBacObligatoires(this.candidature)) {
            this.candidature.bac = this.bacsListe.find(bac => bac.value === 'NBGE').value;
        }
    }

    updateDisplayBacDetail() {
        this.displayBacDetail = (this.candidature.bacAnnee && this.candidature.bacTypeEtablissement) && (this.candidature.bacAnnee > 1900);
    }

    // Open la popup d'aide
    openAide(aideModal, parametre) {
        this.aide = parametre;
        this.modalService.open(aideModal);
    }

    areSpecialitesBacObligatoires(): boolean {
        return Candidature.areSpecialitesBacObligatoires(this.candidature);
    }

    protected readonly constants = CONSTANTS;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/scolarite/scolarite.component.ts